'use strict';
import {combineReducers} from 'redux';
import {INFO_MODAL_NAME} from '../actions/infoModalActions';
import {reduxList as assetReqList} from '../redux/assetReqList';
import {assetFileRequirementReduxItem} from '../redux/files/assetFileRequirementRouterState';
import {createAssetFileRequirementRequestModal} from '../redux/files/createAssetFileRequirement';
import {createProjectFileRequirementRequestModal} from '../redux/files/createProjectFileRequirement';
import {createTemplateFileRequirementRequestModal} from '../redux/files/createTemplateFileRequirement';
import {projectFileRequirementReduxItem} from '../redux/files/projectFileRequirementRouterState';
import {updateAssetFileRequirementRequestModal} from '../redux/files/updateAssetFileRequirement';
import {updateProjectFileRequirementRequestModal} from '../redux/files/updateProjectFileRequirement';
import {updateTemplateFileRequirementRequestModal} from '../redux/files/updateTemplateFileRequirement';
import {assetFormRequirementReduxItem} from '../redux/forms/assetFormRequirementRouterState';
import {createAssetFormRequirementRequestModal} from '../redux/forms/createAssetFormRequirement';
import {createProjectFormRequirementRequestModal} from '../redux/forms/createProjectFormRequirement';
import {createTemplateFormRequirementRequestModal} from '../redux/forms/createTemplateFormRequirement';
import {projectFormRequirementReduxItem} from '../redux/forms/projectFormRequirementRouterState';
import {updateAssetFormReqResponseReduxRequest} from '../redux/forms/updateAssetFormReqResponse';
import {updateAssetFormRequirementRequestModal} from '../redux/forms/updateAssetFormRequirement';
import {updateProjectFormReqResponseReduxRequest} from '../redux/forms/updateProjectFormReqResponse';
import {updateProjectFormRequirementRequestModal} from '../redux/forms/updateProjectFormRequirement';
import {updateTemplateFormRequirementRequestModal} from '../redux/forms/updateTemplateFormRequirement';
import {reduxList as assetReqFilesList} from '../redux/fulfillments/assetReqFilesList';
import {reduxList as projectReqFilesList} from '../redux/fulfillments/projectReqFilesList';
import {reduxList as projectReqList} from '../redux/projectReqList';
import {
  ASSET_FILE_ITEM_NAME,
  ASSET_FILES_LIST_NAME,
  ASSET_FORM_ITEM_NAME,
  ASSET_LIST_NAME,
  CREATE_ASSET_FILE_NAME,
  CREATE_ASSET_FORM_NAME,
  CREATE_PROJECT_FILE_NAME,
  CREATE_PROJECT_FORM_NAME,
  CREATE_TEMPLATE_FILE_NAME,
  CREATE_TEMPLATE_FORM_NAME,
  PROJECT_FILE_ITEM_NAME,
  PROJECT_FILES_LIST_NAME,
  PROJECT_FORM_ITEM_NAME,
  PROJECT_LIST_NAME,
  TEMPLATE_LIST_NAME,
  UPDATE_ASSET_FILE_NAME,
  UPDATE_ASSET_FORM_NAME,
  UPDATE_ASSET_FORM_RESPONSE_NAME,
  UPDATE_PROJECT_FILE_NAME,
  UPDATE_PROJECT_FORM_NAME,
  UPDATE_PROJECT_FORM_RESPONSE_NAME,
  UPDATE_TEMPLATE_FILE_NAME,
  UPDATE_TEMPLATE_FORM_NAME,
} from '../redux/state';
import {reduxList as templateReqList} from '../redux/templateReqList';
import {infoModal} from './infoModalReducers';


export * from './state';

export const requirements = combineReducers({
  [ASSET_FILE_ITEM_NAME]: assetFileRequirementReduxItem.reducers.reducer,
  [ASSET_FILES_LIST_NAME]: assetReqFilesList.reducers.reducer,
  [ASSET_FORM_ITEM_NAME]: assetFormRequirementReduxItem.reducers.reducer,
  [ASSET_LIST_NAME]: assetReqList.reducers.reducer,
  [CREATE_ASSET_FILE_NAME]: createAssetFileRequirementRequestModal.reducers.reducer,
  [CREATE_ASSET_FORM_NAME]: createAssetFormRequirementRequestModal.reducers.reducer,
  [CREATE_PROJECT_FILE_NAME]: createProjectFileRequirementRequestModal.reducers.reducer,
  [CREATE_PROJECT_FORM_NAME]: createProjectFormRequirementRequestModal.reducers.reducer,
  [CREATE_TEMPLATE_FILE_NAME]: createTemplateFileRequirementRequestModal.reducers.reducer,
  [CREATE_TEMPLATE_FORM_NAME]: createTemplateFormRequirementRequestModal.reducers.reducer,
  [INFO_MODAL_NAME]: infoModal,
  [PROJECT_FILE_ITEM_NAME]: projectFileRequirementReduxItem.reducers.reducer,
  [PROJECT_FILES_LIST_NAME]: projectReqFilesList.reducers.reducer,
  [PROJECT_FORM_ITEM_NAME]: projectFormRequirementReduxItem.reducers.reducer,
  [PROJECT_LIST_NAME]: projectReqList.reducers.reducer,
  [TEMPLATE_LIST_NAME]: templateReqList.reducers.reducer,
  [UPDATE_ASSET_FILE_NAME]: updateAssetFileRequirementRequestModal.reducers.reducer,
  [UPDATE_ASSET_FORM_NAME]: updateAssetFormRequirementRequestModal.reducers.reducer,
  [UPDATE_ASSET_FORM_RESPONSE_NAME]: updateAssetFormReqResponseReduxRequest.reducers.reducer,
  [UPDATE_PROJECT_FILE_NAME]: updateProjectFileRequirementRequestModal.reducers.reducer,
  [UPDATE_PROJECT_FORM_NAME]: updateProjectFormRequirementRequestModal.reducers.reducer,
  [UPDATE_PROJECT_FORM_RESPONSE_NAME]: updateProjectFormReqResponseReduxRequest.reducers.reducer,
  [UPDATE_TEMPLATE_FILE_NAME]: updateTemplateFileRequirementRequestModal.reducers.reducer,
  [UPDATE_TEMPLATE_FORM_NAME]: updateTemplateFormRequirementRequestModal.reducers.reducer,
});



// WEBPACK FOOTER //
// ./src/js/requirements/reducers/index.js